import { UnespCoreMenuItem } from '@unesp/core'

export const menuCandidato: UnespCoreMenuItem[] = [
  // Área do Candidato
  {
    displayName: 'Área do Candidato',
    iconName: 'person',
    roles: ['CANDIDATO'],
    route: '/candidato/area-candidato',
    order: 1,
  },
]
